export const env = {
  SHOPIFY_CDN_BASE_URL: "__SHOPIFY_CDN_BASE_URL__",
  REDO_API_SERVER_URL: "__REDO_API_SERVER_URL__",
  REDO_CUSTOMER_PORTAL_SERVER_URL: "__REDO_CUSTOMER_PORTAL_SERVER_URL__",
  MERCHANT_SERVER_URL: "__MERCHANT_SERVER_URL__",
  MERCHANT_APP_URL: "__MERCHANT_APP_URL__",
} as const;

// Development URLs for debugging (Coverage)
// export const env = {
//   SHOPIFY_CDN_BASE_URL: "https://shopify-cdn.getredo.com",
//   REDO_API_SERVER_URL: "https://api.getredo.com",
//   REDO_CUSTOMER_PORTAL_SERVER_URL: "https://customer-portal-server.getredo.com",
//   MERCHANT_SERVER_URL: "https://app-server.getredo.com",
//   MERCHANT_APP_URL: "https://app.getredo.com",
// } as const;

// Development URLs for debugging (Danny)
// export const env = {
//   SHOPIFY_CDN_BASE_URL: "__SHOPIFY_CDN_BASE_URL__",
//   REDO_API_SERVER_URL: "https://api.getredo.dev",
//   REDO_CUSTOMER_PORTAL_SERVER_URL: "https://customer-portal.getredo.dev",
//   MERCHANT_SERVER_URL: "https://m-server.getredo.dev",
//   MERCHANT_APP_URL: "__MERCHANT_APP_URL__",
// } as const;

// Development URLs for debugging (Devin)
// export const env = {
//   SHOPIFY_CDN_BASE_URL: "__SHOPIFY_CDN_BASE_URL__",
//   REDO_API_SERVER_URL: "https://api-devin.getredo.dev",
//   REDO_CUSTOMER_PORTAL_SERVER_URL: "https://customer-portal-devin.getredo.dev",
//   MERCHANT_SERVER_URL: "https://merchant-server-devin.getredo.dev",
//   MERCHANT_APP_URL: "__MERCHANT_APP_URL__",
// } as const;

// Development URLs for debugging (Tommy)
// export const env = {
//   SHOPIFY_CDN_BASE_URL: "__SHOPIFY_CDN_BASE_URL__",
//   REDO_API_SERVER_URL: "https://api-tommy.getredo.dev",
//   REDO_CUSTOMER_PORTAL_SERVER_URL: "https://customer-portal-tommy.getredo.dev",
//   MERCHANT_SERVER_URL: "https://merchant-server-tommy.getredo.dev",
//   MERCHANT_APP_URL: "__MERCHANT_APP_URL__",
// } as const;

// Development URLs for debugging (Harry)
// export const env = {
//   SHOPIFY_CDN_BASE_URL: "__SHOPIFY_CDN_BASE_URL__",
//   REDO_API_SERVER_URL: "https://api-harrison.getredo.dev",
//   REDO_CUSTOMER_PORTAL_SERVER_URL: "https://customer-portal-harrison.getredo.dev",
//   MERCHANT_SERVER_URL: "https://merchant-server-harrison.getredo.dev",
// DEVELOPER NOTE!! when setting up the merchant app url tunnel you need to set the http host header to
// app-vite.getredo.localhost and the origin server name to app-vite.getredo.localhost
// This is necessary for the cross site origin verification that shopify does on the printing api
// You may also need to put this in your conf.sh REDO_MERCHANT_APP_URL=https://app-harrison.getredo.dev
//   MERCHANT_APP_URL: "https://app-harrison.getredo.dev",
// } as const;
